import React from 'react';
import { SVGProps } from './types';

const UncheckedCheckbox = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M17.5 2.54h-15v15h15v-15z"
      />
    </svg>
  );
};

export { UncheckedCheckbox };
